/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { COINSharedApplicationProtosResponsesStatusResponse } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesCalculatedAttributeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesCalculationFormulaResultModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesCreateCalculatedAttributeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesCreateDependentAttributeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesCreateStandardAttributeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesDependentAttributeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesDependentAttributeValueModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesModifyDependentAttributeValuesModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesSimulateCalculationFormulaModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesStandardAttributeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesUpdateCalculatedAttributeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesUpdateDependentAttributeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributesUpdateStandardAttributeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClauseCategoriesClauseCategoryModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClauseCategoriesCreateClauseCategoryModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClauseCategoriesMoveClausesToCategoryModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClauseCategoriesUpdateClauseCategoryModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryCountryNumberSettingsCreateCountryNumberSettingModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryCountryNumberSettingsUpdateCountryNumberSettingModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEclSettingsEclSettingsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEclSettingsUpdateEclSettingsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeeAttributesCreateEmployeeAttributeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeValueTranslationModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeeAttributesEmployeeAttributesTranslationModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeeAttributesListSupportedLanguagesModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeeAttributesMassTranslateEmployeeAttributesModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeeAttributesTranslateEmployeeAttributeValueModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeTranslationModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeesCreateEclEmployeeAttributeExportModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeesEclEmployeeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeesEmployeeAreModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeesQueryEclEmployeeByRuleSetModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeesReplaceEmployeeModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeesUpdateEmployeeAreModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeesUploadedGidsValidationRequestModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibrarySignatureAuthorizationsCreateSignatureAuthorizationSettingsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibrarySignatureAuthorizationsUpdateSignatureAuthorizationSettingsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryUsersSetUsersAsApproverModel } from '@coin/shared/core/util-models';
import { SharedEntitySearchScopeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryAresAreModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryAttributesCalculatedAttributeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryAttributesDependentAttributeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryAttributesStandardAttributeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryClauseCategoriesClauseCategoryModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryUsersUserModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSystemString } from '@coin/shared/core/util-models';
import { SharedRuleEngineRuleSetModel } from '@coin/shared/core/util-models';
import { SharedUploadedGidsValidationResultModel } from '@coin/shared/core/util-models';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface EmploymentConditionLibraryAdminServiceCreateCalculatedAttributeAttributesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryAttributesCreateCalculatedAttributeModel?: EmploymentConditionLibraryAttributesCreateCalculatedAttributeModel;
}

export interface EmploymentConditionLibraryAdminServiceCreateClauseCategoriesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClauseCategoriesCreateClauseCategoryModel?: EmploymentConditionLibraryClauseCategoriesCreateClauseCategoryModel;
}

export interface EmploymentConditionLibraryAdminServiceCreateCountryNumberSettingsRequestParams {
  employmentConditionLibraryCountryNumberSettingsCreateCountryNumberSettingModel?: EmploymentConditionLibraryCountryNumberSettingsCreateCountryNumberSettingModel;
}

export interface EmploymentConditionLibraryAdminServiceCreateDependentAttributeAttributesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryAttributesCreateDependentAttributeModel?: EmploymentConditionLibraryAttributesCreateDependentAttributeModel;
}

export interface EmploymentConditionLibraryAdminServiceCreateEmployeeAttributesRequestParams {
  employeeId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryEmployeeAttributesCreateEmployeeAttributeModel?: EmploymentConditionLibraryEmployeeAttributesCreateEmployeeAttributeModel;
}

export interface EmploymentConditionLibraryAdminServiceCreateExportEmployeesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryEmployeesCreateEclEmployeeAttributeExportModel?: EmploymentConditionLibraryEmployeesCreateEclEmployeeAttributeExportModel;
}

export interface EmploymentConditionLibraryAdminServiceCreateSettingsSignatureAuthorizationsRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibrarySignatureAuthorizationsCreateSignatureAuthorizationSettingsModel?: EmploymentConditionLibrarySignatureAuthorizationsCreateSignatureAuthorizationSettingsModel;
}

export interface EmploymentConditionLibraryAdminServiceCreateStandardAttributeAttributesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryAttributesCreateStandardAttributeModel?: EmploymentConditionLibraryAttributesCreateStandardAttributeModel;
}

export interface EmploymentConditionLibraryAdminServiceDeleteAttributesRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceDeleteClauseCategoriesRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceDeleteCountryNumberSettingsRequestParams {
  id: string;
}

export interface EmploymentConditionLibraryAdminServiceDeleteEmployeeAttributesRequestParams {
  employeeId: string;
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceDeleteSettingsSignatureAuthorizationsRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceExportAresRequestParams {
  /** The search text to find. */
  name?: string;
  /** The search text to find. */
  areCode?: string;
  /** The search text to find. */
  parentAreCode?: string;
  /** The country\&#39;s ISO2 code to find. */
  countryCode?: string;
  /** The search text to find. */
  searchQuery?: string;
}

export interface EmploymentConditionLibraryAdminServiceExportAttributesRequestParams {
  /** Type of attributes that should be exported. */
  type: 'Standard' | 'Dependent' | 'Calculated';
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type2?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  /** ECL Module. */
  module2?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceGetCountryNumberSettingsRequestParams {
  countryCode?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceGetEclSettingsRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceGetEmployeesRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceGetFormulaSimulationAttributesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryAttributesSimulateCalculationFormulaModel?: EmploymentConditionLibraryAttributesSimulateCalculationFormulaModel;
}

export interface EmploymentConditionLibraryAdminServiceGetScopeEmployeesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceGetSimulatedPopulationSignatureAuthorizationsRequestParams {
  id: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  sharedRuleEngineRuleSetModel?: SharedRuleEngineRuleSetModel;
}

export interface EmploymentConditionLibraryAdminServiceModifyDependenciesAttributesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryAttributesModifyDependentAttributeValuesModel?: EmploymentConditionLibraryAttributesModifyDependentAttributeValuesModel;
}

export interface EmploymentConditionLibraryAdminServiceMoveClauseToCategoryClauseCategoriesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClauseCategoriesMoveClausesToCategoryModel?: EmploymentConditionLibraryClauseCategoriesMoveClausesToCategoryModel;
}

export interface EmploymentConditionLibraryAdminServiceQueryActualPopulationSignatureAuthorizationsRequestParams {
  id: string;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryAresRequestParams {
  page?: number;
  size?: number;
  /** The search text to find. */
  name?: string;
  /** The search text to find. */
  areCode?: string;
  /** The search text to find. */
  parentAreCode?: string;
  /** The country\&#39;s ISO2 code to find. */
  countryCode?: string;
  /** The search text to find. */
  searchQuery?: string;
}

export interface EmploymentConditionLibraryAdminServiceQueryByRuleSetEmployeesRequestParams {
  page?: number;
  size?: number;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryEmployeesQueryEclEmployeeByRuleSetModel?: EmploymentConditionLibraryEmployeesQueryEclEmployeeByRuleSetModel;
}

export interface EmploymentConditionLibraryAdminServiceQueryCalculatedAttributesAttributesRequestParams {
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module2?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryClauseCategoriesRequestParams {
  type: string;
  searchQuery?: string;
  cluster?: string;
  subject?: string;
  topic?: string;
  queryCountries?: Array<string>;
  queryLegalEntities?: Array<string>;
  queryClusters?: Array<string>;
  querySubjects?: Array<string>;
  queryTopics?: Array<string>;
  queryNames?: Array<string>;
  queryClauseGroups?: Array<string>;
  querySearch?: string;
  queryClauseStatus?: Array<'Draft' | 'Published' | 'Retired' | 'PendingApproval'>;
  queryEffectiveTo?: string;
  queryWithContent?: boolean;
  queryLocalLanguage?: string;
  queryEffectiveFrom?: string;
  queryIsQueryingForTemplate?: boolean;
  queryEffectiveDate?: string;
  categoryQueryClusterValues?: Array<string>;
  categoryQueryClusterType?: string;
  categoryQuerySubjectValues?: Array<string>;
  categoryQuerySubjectType?: string;
  categoryQueryTopicValues?: Array<string>;
  categoryQueryTopicType?: string;
  pageablePage?: number;
  pageableSize?: number;
  parentId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryDependenciesAttributesRequestParams {
  attributeId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryDependentAttributesAttributesRequestParams {
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module2?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryEmployeeAttributesRequestParams {
  employeeId: string;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  employeeId2?: string;
  attributeName?: Array<string>;
  dataSource?: Array<string>;
  effectiveFrom?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryEmployeesRequestParams {
  query?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryFieldValueEmployeesRequestParams {
  fieldName: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4;
  gid?: string;
  fullName?: string;
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSource?: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryFieldValuesAttributesRequestParams {
  fieldName: string;
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryFieldValuesEmployeeAttributesRequestParams {
  employeeId: string;
  fieldName: string;
  pageablePage?: number;
  pageableSize?: number;
  targetProperty?: 0 | 1 | 2;
  employeeId2?: string;
  attributeName?: Array<string>;
  dataSource?: Array<string>;
  effectiveFrom?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryFieldValuesSignatureAuthorizationsRequestParams {
  queryTargetProperty?: 0;
  queryLegalEntity?: Array<string>;
  pageablePage?: number;
  pageableSize?: number;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryLegalEntityAttributesAttributesRequestParams {
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module2?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQuerySignatureAuthorizationsRequestParams {
  queryTargetProperty?: 0;
  queryLegalEntity?: Array<string>;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryStandardAttributesAttributesRequestParams {
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module2?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceQueryUsersRequestParams {
  searchString?: string;
  firstname?: Array<string>;
  lastname?: Array<string>;
  middlename?: Array<string>;
  gid?: Array<string>;
  isApproverAuthorized?: boolean;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceRecalculateSettingsSignatureAuthorizationsRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminServiceReplaceEmployeeEmployeesRequestParams {
  employeeId: string;
  employmentConditionLibraryEmployeesReplaceEmployeeModel?: EmploymentConditionLibraryEmployeesReplaceEmployeeModel;
}

export interface EmploymentConditionLibraryAdminServiceSetUserAsApproverUsersRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryUsersSetUsersAsApproverModel?: EmploymentConditionLibraryUsersSetUsersAsApproverModel;
}

export interface EmploymentConditionLibraryAdminServiceTranslateEmployeeAttributeEmployeeAttributeTranslationRequestParams {
  employmentConditionLibraryEmployeeAttributesTranslateEmployeeAttributeValueModel?: Array<EmploymentConditionLibraryEmployeeAttributesTranslateEmployeeAttributeValueModel>;
}

export interface EmploymentConditionLibraryAdminServiceTranslateEmployeeAttributesEmployeeAttributeTranslationRequestParams {
  employmentConditionLibraryEmployeeAttributesMassTranslateEmployeeAttributesModel?: EmploymentConditionLibraryEmployeeAttributesMassTranslateEmployeeAttributesModel;
}

export interface EmploymentConditionLibraryAdminServiceUpdateCalculatedAttributeAttributesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryAttributesUpdateCalculatedAttributeModel?: EmploymentConditionLibraryAttributesUpdateCalculatedAttributeModel;
}

export interface EmploymentConditionLibraryAdminServiceUpdateClauseCategoriesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClauseCategoriesUpdateClauseCategoryModel?: EmploymentConditionLibraryClauseCategoriesUpdateClauseCategoryModel;
}

export interface EmploymentConditionLibraryAdminServiceUpdateCountryNumberSettingsRequestParams {
  id: string;
  employmentConditionLibraryCountryNumberSettingsUpdateCountryNumberSettingModel?: EmploymentConditionLibraryCountryNumberSettingsUpdateCountryNumberSettingModel;
}

export interface EmploymentConditionLibraryAdminServiceUpdateDependentAttributeAttributesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryAttributesUpdateDependentAttributeModel?: EmploymentConditionLibraryAttributesUpdateDependentAttributeModel;
}

export interface EmploymentConditionLibraryAdminServiceUpdateEclSettingsRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryEclSettingsUpdateEclSettingsModel?: EmploymentConditionLibraryEclSettingsUpdateEclSettingsModel;
}

export interface EmploymentConditionLibraryAdminServiceUpdateEmployeeAresEmployeesRequestParams {
  employeeId: string;
  employmentConditionLibraryEmployeesUpdateEmployeeAreModel?: EmploymentConditionLibraryEmployeesUpdateEmployeeAreModel;
}

export interface EmploymentConditionLibraryAdminServiceUpdateEmployeeAttributeValuesEmployeeAttributeTranslationRequestParams {
  employmentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeTranslationModel?: Array<EmploymentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeTranslationModel>;
}

export interface EmploymentConditionLibraryAdminServiceUpdateEmployeeAttributesRequestParams {
  employeeId: string;
  employmentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeModel?: EmploymentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeModel;
}

export interface EmploymentConditionLibraryAdminServiceUpdateLegalEntityAttributeAttributesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryAttributesUpdateStandardAttributeModel?: EmploymentConditionLibraryAttributesUpdateStandardAttributeModel;
}

export interface EmploymentConditionLibraryAdminServiceUpdateSettingsSignatureAuthorizationsRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibrarySignatureAuthorizationsUpdateSignatureAuthorizationSettingsModel?: EmploymentConditionLibrarySignatureAuthorizationsUpdateSignatureAuthorizationSettingsModel;
}

export interface EmploymentConditionLibraryAdminServiceUpdateStandardAttributeAttributesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryAttributesUpdateStandardAttributeModel?: EmploymentConditionLibraryAttributesUpdateStandardAttributeModel;
}

export interface EmploymentConditionLibraryAdminServiceValidateEmployeesRequestParams {
  employmentConditionLibraryEmployeesUploadedGidsValidationRequestModel?: EmploymentConditionLibraryEmployeesUploadedGidsValidationRequestModel;
}

@Injectable({
  providedIn: 'root'
})
export class EmploymentConditionLibraryAdminService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateCalculatedAttributeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryAttributesCalculatedAttributeModel>;
  public createCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateCalculatedAttributeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryAttributesCalculatedAttributeModel>>;
  public createCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateCalculatedAttributeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryAttributesCalculatedAttributeModel>>;
  public createCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateCalculatedAttributeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryAttributesCreateCalculatedAttributeModel =
      requestParameters?.employmentConditionLibraryAttributesCreateCalculatedAttributeModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/calculated`;
    return this.httpClient.request<EmploymentConditionLibraryAttributesCalculatedAttributeModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryAttributesCreateCalculatedAttributeModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateClauseCategoriesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClauseCategoriesClauseCategoryModel>;
  public createClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateClauseCategoriesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClauseCategoriesClauseCategoryModel>>;
  public createClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateClauseCategoriesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClauseCategoriesClauseCategoryModel>>;
  public createClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateClauseCategoriesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryClauseCategoriesCreateClauseCategoryModel =
      requestParameters?.employmentConditionLibraryClauseCategoriesCreateClauseCategoryModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/clause-categories`;
    return this.httpClient.request<EmploymentConditionLibraryClauseCategoriesClauseCategoryModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClauseCategoriesCreateClauseCategoryModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateCountryNumberSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>;
  public createCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateCountryNumberSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>>;
  public createCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateCountryNumberSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>>;
  public createCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateCountryNumberSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employmentConditionLibraryCountryNumberSettingsCreateCountryNumberSettingModel =
      requestParameters?.employmentConditionLibraryCountryNumberSettingsCreateCountryNumberSettingModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/country-number-settings`;
    return this.httpClient.request<EmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryCountryNumberSettingsCreateCountryNumberSettingModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createDependentAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateDependentAttributeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryAttributesDependentAttributeModel>;
  public createDependentAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateDependentAttributeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryAttributesDependentAttributeModel>>;
  public createDependentAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateDependentAttributeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryAttributesDependentAttributeModel>>;
  public createDependentAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateDependentAttributeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryAttributesCreateDependentAttributeModel =
      requestParameters?.employmentConditionLibraryAttributesCreateDependentAttributeModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/dependent`;
    return this.httpClient.request<EmploymentConditionLibraryAttributesDependentAttributeModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryAttributesCreateDependentAttributeModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateEmployeeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>;
  public createEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateEmployeeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>>;
  public createEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateEmployeeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>>;
  public createEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateEmployeeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling createEmployeeAttributes.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryEmployeeAttributesCreateEmployeeAttributeModel =
      requestParameters?.employmentConditionLibraryEmployeeAttributesCreateEmployeeAttributeModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attributes`;
    return this.httpClient.request<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryEmployeeAttributesCreateEmployeeAttributeModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createExportEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateExportEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public createExportEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateExportEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public createExportEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateExportEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public createExportEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateExportEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryEmployeesCreateEclEmployeeAttributeExportModel =
      requestParameters?.employmentConditionLibraryEmployeesCreateEclEmployeeAttributeExportModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/attributes/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryEmployeesCreateEclEmployeeAttributeExportModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateSettingsSignatureAuthorizationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>;
  public createSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateSettingsSignatureAuthorizationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>>;
  public createSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateSettingsSignatureAuthorizationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>>;
  public createSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateSettingsSignatureAuthorizationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibrarySignatureAuthorizationsCreateSignatureAuthorizationSettingsModel =
      requestParameters?.employmentConditionLibrarySignatureAuthorizationsCreateSignatureAuthorizationSettingsModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/signature-authorizations`;
    return this.httpClient.request<EmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibrarySignatureAuthorizationsCreateSignatureAuthorizationSettingsModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateStandardAttributeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryAttributesStandardAttributeModel>;
  public createStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateStandardAttributeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryAttributesStandardAttributeModel>>;
  public createStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateStandardAttributeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryAttributesStandardAttributeModel>>;
  public createStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceCreateStandardAttributeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryAttributesCreateStandardAttributeModel =
      requestParameters?.employmentConditionLibraryAttributesCreateStandardAttributeModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/standard`;
    return this.httpClient.request<EmploymentConditionLibraryAttributesStandardAttributeModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryAttributesCreateStandardAttributeModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<boolean>;
  public deleteAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<boolean>>;
  public deleteAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<boolean>>;
  public deleteAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteAttributes.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<boolean>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteClauseCategoriesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteClauseCategoriesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteClauseCategoriesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteClauseCategoriesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteClauseCategories.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/clause-categories/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteCountryNumberSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public deleteCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteCountryNumberSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteCountryNumberSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteCountryNumberSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteCountryNumberSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/country-number-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteEmployeeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public deleteEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteEmployeeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteEmployeeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteEmployeeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling deleteEmployeeAttributes.');
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteEmployeeAttributes.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attributes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteSettingsSignatureAuthorizationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public deleteSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteSettingsSignatureAuthorizationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteSettingsSignatureAuthorizationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceDeleteSettingsSignatureAuthorizationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling deleteSettingsSignatureAuthorizations.'
      );
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/signature-authorizations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Exports existing ares by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportAres(
    requestParameters?: EmploymentConditionLibraryAdminServiceExportAresRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportAres(
    requestParameters?: EmploymentConditionLibraryAdminServiceExportAresRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportAres(
    requestParameters?: EmploymentConditionLibraryAdminServiceExportAresRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportAres(
    requestParameters?: EmploymentConditionLibraryAdminServiceExportAresRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const name = requestParameters?.name;
    const areCode = requestParameters?.areCode;
    const parentAreCode = requestParameters?.parentAreCode;
    const countryCode = requestParameters?.countryCode;
    const searchQuery = requestParameters?.searchQuery;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (areCode !== undefined && areCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>areCode, 'AreCode');
    }
    if (parentAreCode !== undefined && parentAreCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>parentAreCode, 'ParentAreCode');
    }
    if (countryCode !== undefined && countryCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>countryCode, 'CountryCode');
    }
    if (searchQuery !== undefined && searchQuery !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchQuery, 'SearchQuery');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/condition-library/ares/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Exports attributes matching the specified query
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceExportAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceExportAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceExportAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceExportAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const type = requestParameters?.type;
    if (type === null || type === undefined) {
      throw new Error('Required parameter type was null or undefined when calling exportAttributes.');
    }
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const dataSources = requestParameters?.dataSources;
    const name = requestParameters?.name;
    const isPlaceholder = requestParameters?.isPlaceholder;
    const isRuleRelevant = requestParameters?.isRuleRelevant;
    const isGlobal = requestParameters?.isGlobal;
    const hasPreviousValue = requestParameters?.hasPreviousValue;
    const isMultipleAssignmentAllowed = requestParameters?.isMultipleAssignmentAllowed;
    const effectiveTo = requestParameters?.effectiveTo;
    const targetProperty = requestParameters?.targetProperty;
    const discriminator = requestParameters?.discriminator;
    const type2 = requestParameters?.type2;
    const interdependencyId = requestParameters?.interdependencyId;
    const module = requestParameters?.module;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const module2 = requestParameters?.module2;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (legalEntity) {
      legalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntity');
      });
    }
    if (dataSources) {
      dataSources.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DataSources');
      });
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (isPlaceholder !== undefined && isPlaceholder !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isPlaceholder, 'IsPlaceholder');
    }
    if (isRuleRelevant !== undefined && isRuleRelevant !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isRuleRelevant, 'IsRuleRelevant');
    }
    if (isGlobal !== undefined && isGlobal !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isGlobal, 'IsGlobal');
    }
    if (hasPreviousValue !== undefined && hasPreviousValue !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hasPreviousValue,
        'HasPreviousValue'
      );
    }
    if (isMultipleAssignmentAllowed !== undefined && isMultipleAssignmentAllowed !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isMultipleAssignmentAllowed,
        'IsMultipleAssignmentAllowed'
      );
    }
    if (effectiveTo !== undefined && effectiveTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveTo, 'EffectiveTo');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (discriminator !== undefined && discriminator !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>discriminator, 'Discriminator');
    }
    if (type2) {
      type2.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Type');
      });
    }
    if (interdependencyId !== undefined && interdependencyId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>interdependencyId,
        'InterdependencyId'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (module2 !== undefined && module2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module2, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/export/${this.configuration.encodeParam({ name: 'type', value: type, in: 'path', style: 'simple', explode: false, dataType: "'Standard' | 'Dependent' | 'Calculated'", dataFormat: undefined })}`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetCountryNumberSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>;
  public getCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetCountryNumberSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfEmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>
  >;
  public getCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetCountryNumberSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>>;
  public getCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetCountryNumberSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const countryCode = requestParameters?.countryCode;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (countryCode !== undefined && countryCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>countryCode, 'CountryCode');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/country-number-settings`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEclSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetEclSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryEclSettingsEclSettingsModel>;
  public getEclSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetEclSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryEclSettingsEclSettingsModel>>;
  public getEclSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetEclSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryEclSettingsEclSettingsModel>>;
  public getEclSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetEclSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/settings`;
    return this.httpClient.request<EmploymentConditionLibraryEclSettingsEclSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryEmployeesEclEmployeeModel>;
  public getEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public getEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public getEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getEmployees.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryEmployeesEclEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFormulaSimulationAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetFormulaSimulationAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryAttributesCalculationFormulaResultModel>;
  public getFormulaSimulationAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetFormulaSimulationAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryAttributesCalculationFormulaResultModel>>;
  public getFormulaSimulationAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetFormulaSimulationAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryAttributesCalculationFormulaResultModel>>;
  public getFormulaSimulationAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetFormulaSimulationAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryAttributesSimulateCalculationFormulaModel =
      requestParameters?.employmentConditionLibraryAttributesSimulateCalculationFormulaModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/formula-simulation`;
    return this.httpClient.request<EmploymentConditionLibraryAttributesCalculationFormulaResultModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryAttributesSimulateCalculationFormulaModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getScopeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetScopeEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedEntitySearchScopeModel>;
  public getScopeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetScopeEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedEntitySearchScopeModel>>;
  public getScopeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetScopeEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedEntitySearchScopeModel>>;
  public getScopeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetScopeEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/scope`;
    return this.httpClient.request<SharedEntitySearchScopeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSimulatedPopulationSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetSimulatedPopulationSignatureAuthorizationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>;
  public getSimulatedPopulationSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetSimulatedPopulationSignatureAuthorizationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>>;
  public getSimulatedPopulationSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetSimulatedPopulationSignatureAuthorizationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>>;
  public getSimulatedPopulationSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceGetSimulatedPopulationSignatureAuthorizationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling getSimulatedPopulationSignatureAuthorizations.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const module = requestParameters?.module;
    const sharedRuleEngineRuleSetModel = requestParameters?.sharedRuleEngineRuleSetModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/signature-authorizations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: sharedRuleEngineRuleSetModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSupportedLanguagesEmployeeAttributeTranslation(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryEmployeeAttributesListSupportedLanguagesModel>;
  public getSupportedLanguagesEmployeeAttributeTranslation(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryEmployeeAttributesListSupportedLanguagesModel>>;
  public getSupportedLanguagesEmployeeAttributeTranslation(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryEmployeeAttributesListSupportedLanguagesModel>>;
  public getSupportedLanguagesEmployeeAttributeTranslation(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/attributes/translation/list-supported-languages`;
    return this.httpClient.request<EmploymentConditionLibraryEmployeeAttributesListSupportedLanguagesModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public modifyDependenciesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceModifyDependenciesAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<EmploymentConditionLibraryAttributesDependentAttributeValueModel>>;
  public modifyDependenciesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceModifyDependenciesAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<EmploymentConditionLibraryAttributesDependentAttributeValueModel>>>;
  public modifyDependenciesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceModifyDependenciesAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<EmploymentConditionLibraryAttributesDependentAttributeValueModel>>>;
  public modifyDependenciesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceModifyDependenciesAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryAttributesModifyDependentAttributeValuesModel =
      requestParameters?.employmentConditionLibraryAttributesModifyDependentAttributeValuesModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/dependent`;
    return this.httpClient.request<Array<EmploymentConditionLibraryAttributesDependentAttributeValueModel>>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryAttributesModifyDependentAttributeValuesModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public moveClauseToCategoryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceMoveClauseToCategoryClauseCategoriesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public moveClauseToCategoryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceMoveClauseToCategoryClauseCategoriesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public moveClauseToCategoryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceMoveClauseToCategoryClauseCategoriesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public moveClauseToCategoryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceMoveClauseToCategoryClauseCategoriesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryClauseCategoriesMoveClausesToCategoryModel =
      requestParameters?.employmentConditionLibraryClauseCategoriesMoveClausesToCategoryModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/clause-categories`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClauseCategoriesMoveClausesToCategoryModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryActualPopulationSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryActualPopulationSignatureAuthorizationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>;
  public queryActualPopulationSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryActualPopulationSignatureAuthorizationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>>;
  public queryActualPopulationSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryActualPopulationSignatureAuthorizationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>>;
  public queryActualPopulationSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryActualPopulationSignatureAuthorizationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling queryActualPopulationSignatureAuthorizations.'
      );
    }
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortableOrderBy = requestParameters?.sortableOrderBy;
    const sortableProperty = requestParameters?.sortableProperty;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortableOrderBy !== undefined && sortableOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortableOrderBy, 'Sortable.OrderBy');
    }
    if (sortableProperty !== undefined && sortableProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>sortableProperty,
        'Sortable.Property'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/signature-authorizations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/actual-population`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing ares by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAres(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryAresRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryAresAreModel>;
  public queryAres(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryAresRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryAresAreModel>>;
  public queryAres(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryAresRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryAresAreModel>>;
  public queryAres(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryAresRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const name = requestParameters?.name;
    const areCode = requestParameters?.areCode;
    const parentAreCode = requestParameters?.parentAreCode;
    const countryCode = requestParameters?.countryCode;
    const searchQuery = requestParameters?.searchQuery;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (areCode !== undefined && areCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>areCode, 'AreCode');
    }
    if (parentAreCode !== undefined && parentAreCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>parentAreCode, 'ParentAreCode');
    }
    if (countryCode !== undefined && countryCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>countryCode, 'CountryCode');
    }
    if (searchQuery !== undefined && searchQuery !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchQuery, 'SearchQuery');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/condition-library/ares`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryAresAreModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryByRuleSetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryByRuleSetEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>;
  public queryByRuleSetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryByRuleSetEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public queryByRuleSetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryByRuleSetEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public queryByRuleSetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryByRuleSetEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const module = requestParameters?.module;
    const employmentConditionLibraryEmployeesQueryEclEmployeeByRuleSetModel =
      requestParameters?.employmentConditionLibraryEmployeesQueryEclEmployeeByRuleSetModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/query`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryEmployeesQueryEclEmployeeByRuleSetModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryCalculatedAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryCalculatedAttributesAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryAttributesCalculatedAttributeModel>;
  public queryCalculatedAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryCalculatedAttributesAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryAttributesCalculatedAttributeModel>>;
  public queryCalculatedAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryCalculatedAttributesAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryAttributesCalculatedAttributeModel>>;
  public queryCalculatedAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryCalculatedAttributesAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const dataSources = requestParameters?.dataSources;
    const name = requestParameters?.name;
    const isPlaceholder = requestParameters?.isPlaceholder;
    const isRuleRelevant = requestParameters?.isRuleRelevant;
    const isGlobal = requestParameters?.isGlobal;
    const hasPreviousValue = requestParameters?.hasPreviousValue;
    const isMultipleAssignmentAllowed = requestParameters?.isMultipleAssignmentAllowed;
    const effectiveTo = requestParameters?.effectiveTo;
    const targetProperty = requestParameters?.targetProperty;
    const discriminator = requestParameters?.discriminator;
    const type = requestParameters?.type;
    const interdependencyId = requestParameters?.interdependencyId;
    const module = requestParameters?.module;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const module2 = requestParameters?.module2;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (legalEntity) {
      legalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntity');
      });
    }
    if (dataSources) {
      dataSources.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DataSources');
      });
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (isPlaceholder !== undefined && isPlaceholder !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isPlaceholder, 'IsPlaceholder');
    }
    if (isRuleRelevant !== undefined && isRuleRelevant !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isRuleRelevant, 'IsRuleRelevant');
    }
    if (isGlobal !== undefined && isGlobal !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isGlobal, 'IsGlobal');
    }
    if (hasPreviousValue !== undefined && hasPreviousValue !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hasPreviousValue,
        'HasPreviousValue'
      );
    }
    if (isMultipleAssignmentAllowed !== undefined && isMultipleAssignmentAllowed !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isMultipleAssignmentAllowed,
        'IsMultipleAssignmentAllowed'
      );
    }
    if (effectiveTo !== undefined && effectiveTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveTo, 'EffectiveTo');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (discriminator !== undefined && discriminator !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>discriminator, 'Discriminator');
    }
    if (type) {
      type.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Type');
      });
    }
    if (interdependencyId !== undefined && interdependencyId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>interdependencyId,
        'InterdependencyId'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (module2 !== undefined && module2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module2, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/calculated`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryAttributesCalculatedAttributeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryClauseCategoriesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryClauseCategoriesClauseCategoryModel>;
  public queryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryClauseCategoriesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryClauseCategoriesClauseCategoryModel>>;
  public queryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryClauseCategoriesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryClauseCategoriesClauseCategoryModel>>;
  public queryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryClauseCategoriesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const type = requestParameters?.type;
    if (type === null || type === undefined) {
      throw new Error('Required parameter type was null or undefined when calling queryClauseCategories.');
    }
    const searchQuery = requestParameters?.searchQuery;
    const cluster = requestParameters?.cluster;
    const subject = requestParameters?.subject;
    const topic = requestParameters?.topic;
    const queryCountries = requestParameters?.queryCountries;
    const queryLegalEntities = requestParameters?.queryLegalEntities;
    const queryClusters = requestParameters?.queryClusters;
    const querySubjects = requestParameters?.querySubjects;
    const queryTopics = requestParameters?.queryTopics;
    const queryNames = requestParameters?.queryNames;
    const queryClauseGroups = requestParameters?.queryClauseGroups;
    const querySearch = requestParameters?.querySearch;
    const queryClauseStatus = requestParameters?.queryClauseStatus;
    const queryEffectiveTo = requestParameters?.queryEffectiveTo;
    const queryWithContent = requestParameters?.queryWithContent;
    const queryLocalLanguage = requestParameters?.queryLocalLanguage;
    const queryEffectiveFrom = requestParameters?.queryEffectiveFrom;
    const queryIsQueryingForTemplate = requestParameters?.queryIsQueryingForTemplate;
    const queryEffectiveDate = requestParameters?.queryEffectiveDate;
    const categoryQueryClusterValues = requestParameters?.categoryQueryClusterValues;
    const categoryQueryClusterType = requestParameters?.categoryQueryClusterType;
    const categoryQuerySubjectValues = requestParameters?.categoryQuerySubjectValues;
    const categoryQuerySubjectType = requestParameters?.categoryQuerySubjectType;
    const categoryQueryTopicValues = requestParameters?.categoryQueryTopicValues;
    const categoryQueryTopicType = requestParameters?.categoryQueryTopicType;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const parentId = requestParameters?.parentId;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (type !== undefined && type !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>type, 'Type');
    }
    if (searchQuery !== undefined && searchQuery !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchQuery, 'SearchQuery');
    }
    if (cluster !== undefined && cluster !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>cluster, 'Cluster');
    }
    if (subject !== undefined && subject !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subject, 'Subject');
    }
    if (topic !== undefined && topic !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>topic, 'Topic');
    }
    if (queryCountries) {
      queryCountries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Countries');
      });
    }
    if (queryLegalEntities) {
      queryLegalEntities.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LegalEntities');
      });
    }
    if (queryClusters) {
      queryClusters.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Clusters');
      });
    }
    if (querySubjects) {
      querySubjects.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Subjects');
      });
    }
    if (queryTopics) {
      queryTopics.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Topics');
      });
    }
    if (queryNames) {
      queryNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Names');
      });
    }
    if (queryClauseGroups) {
      queryClauseGroups.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ClauseGroups');
      });
    }
    if (querySearch !== undefined && querySearch !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySearch, 'Query.Search');
    }
    if (queryClauseStatus) {
      queryClauseStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ClauseStatus');
      });
    }
    if (queryEffectiveTo !== undefined && queryEffectiveTo !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveTo,
        'Query.EffectiveTo'
      );
    }
    if (queryWithContent !== undefined && queryWithContent !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryWithContent,
        'Query.WithContent'
      );
    }
    if (queryLocalLanguage !== undefined && queryLocalLanguage !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryLocalLanguage,
        'Query.LocalLanguage'
      );
    }
    if (queryEffectiveFrom !== undefined && queryEffectiveFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveFrom,
        'Query.EffectiveFrom'
      );
    }
    if (queryIsQueryingForTemplate !== undefined && queryIsQueryingForTemplate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsQueryingForTemplate,
        'Query.IsQueryingForTemplate'
      );
    }
    if (queryEffectiveDate !== undefined && queryEffectiveDate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveDate,
        'Query.EffectiveDate'
      );
    }
    if (categoryQueryClusterValues) {
      categoryQueryClusterValues.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CategoryQuery.Cluster.Values'
        );
      });
    }
    if (categoryQueryClusterType !== undefined && categoryQueryClusterType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>categoryQueryClusterType,
        'CategoryQuery.Cluster.Type'
      );
    }
    if (categoryQuerySubjectValues) {
      categoryQuerySubjectValues.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CategoryQuery.Subject.Values'
        );
      });
    }
    if (categoryQuerySubjectType !== undefined && categoryQuerySubjectType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>categoryQuerySubjectType,
        'CategoryQuery.Subject.Type'
      );
    }
    if (categoryQueryTopicValues) {
      categoryQueryTopicValues.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CategoryQuery.Topic.Values'
        );
      });
    }
    if (categoryQueryTopicType !== undefined && categoryQueryTopicType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>categoryQueryTopicType,
        'CategoryQuery.Topic.Type'
      );
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (parentId !== undefined && parentId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>parentId, 'ParentId');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/clause-categories`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryClauseCategoriesClauseCategoryModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryDependenciesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryDependenciesAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<EmploymentConditionLibraryAttributesDependentAttributeValueModel>>;
  public queryDependenciesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryDependenciesAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<EmploymentConditionLibraryAttributesDependentAttributeValueModel>>>;
  public queryDependenciesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryDependenciesAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<EmploymentConditionLibraryAttributesDependentAttributeValueModel>>>;
  public queryDependenciesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryDependenciesAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const attributeId = requestParameters?.attributeId;
    if (attributeId === null || attributeId === undefined) {
      throw new Error('Required parameter attributeId was null or undefined when calling queryDependenciesAttributes.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/${this.configuration.encodeParam({ name: 'attributeId', value: attributeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/dependencies`;
    return this.httpClient.request<Array<EmploymentConditionLibraryAttributesDependentAttributeValueModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryDependentAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryDependentAttributesAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryAttributesDependentAttributeModel>;
  public queryDependentAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryDependentAttributesAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryAttributesDependentAttributeModel>>;
  public queryDependentAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryDependentAttributesAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryAttributesDependentAttributeModel>>;
  public queryDependentAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryDependentAttributesAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const dataSources = requestParameters?.dataSources;
    const name = requestParameters?.name;
    const isPlaceholder = requestParameters?.isPlaceholder;
    const isRuleRelevant = requestParameters?.isRuleRelevant;
    const isGlobal = requestParameters?.isGlobal;
    const hasPreviousValue = requestParameters?.hasPreviousValue;
    const isMultipleAssignmentAllowed = requestParameters?.isMultipleAssignmentAllowed;
    const effectiveTo = requestParameters?.effectiveTo;
    const targetProperty = requestParameters?.targetProperty;
    const discriminator = requestParameters?.discriminator;
    const type = requestParameters?.type;
    const interdependencyId = requestParameters?.interdependencyId;
    const module = requestParameters?.module;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const module2 = requestParameters?.module2;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (legalEntity) {
      legalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntity');
      });
    }
    if (dataSources) {
      dataSources.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DataSources');
      });
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (isPlaceholder !== undefined && isPlaceholder !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isPlaceholder, 'IsPlaceholder');
    }
    if (isRuleRelevant !== undefined && isRuleRelevant !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isRuleRelevant, 'IsRuleRelevant');
    }
    if (isGlobal !== undefined && isGlobal !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isGlobal, 'IsGlobal');
    }
    if (hasPreviousValue !== undefined && hasPreviousValue !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hasPreviousValue,
        'HasPreviousValue'
      );
    }
    if (isMultipleAssignmentAllowed !== undefined && isMultipleAssignmentAllowed !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isMultipleAssignmentAllowed,
        'IsMultipleAssignmentAllowed'
      );
    }
    if (effectiveTo !== undefined && effectiveTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveTo, 'EffectiveTo');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (discriminator !== undefined && discriminator !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>discriminator, 'Discriminator');
    }
    if (type) {
      type.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Type');
      });
    }
    if (interdependencyId !== undefined && interdependencyId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>interdependencyId,
        'InterdependencyId'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (module2 !== undefined && module2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module2, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/dependent`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryAttributesDependentAttributeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryEmployeeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>;
  public queryEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryEmployeeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfEmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>
  >;
  public queryEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryEmployeeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>>;
  public queryEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryEmployeeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling queryEmployeeAttributes.');
    }
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortableOrderBy = requestParameters?.sortableOrderBy;
    const sortableProperty = requestParameters?.sortableProperty;
    const employeeId2 = requestParameters?.employeeId2;
    const attributeName = requestParameters?.attributeName;
    const dataSource = requestParameters?.dataSource;
    const effectiveFrom = requestParameters?.effectiveFrom;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortableOrderBy !== undefined && sortableOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortableOrderBy, 'Sortable.OrderBy');
    }
    if (sortableProperty !== undefined && sortableProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>sortableProperty,
        'Sortable.Property'
      );
    }
    if (employeeId2 !== undefined && employeeId2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>employeeId2, 'EmployeeId');
    }
    if (attributeName) {
      attributeName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AttributeName');
      });
    }
    if (dataSource) {
      dataSource.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DataSource');
      });
    }
    if (effectiveFrom !== undefined && effectiveFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveFrom, 'EffectiveFrom');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attributes`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>;
  public queryEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public queryEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public queryEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const query = requestParameters?.query;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (query !== undefined && query !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>query, 'query');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/query`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValueEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<string>>;
  public queryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValueEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<string>>>;
  public queryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValueEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<string>>>;
  public queryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValueEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const fieldName = requestParameters?.fieldName;
    if (fieldName === null || fieldName === undefined) {
      throw new Error('Required parameter fieldName was null or undefined when calling queryFieldValueEmployees.');
    }
    const targetProperty = requestParameters?.targetProperty;
    const gid = requestParameters?.gid;
    const fullName = requestParameters?.fullName;
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const dataSource = requestParameters?.dataSource;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'Gid');
    }
    if (fullName !== undefined && fullName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>fullName, 'FullName');
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (legalEntity) {
      legalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntity');
      });
    }
    if (dataSource) {
      dataSource.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DataSource');
      });
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<Array<string>>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<string>>;
  public queryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<string>>>;
  public queryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<string>>>;
  public queryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const fieldName = requestParameters?.fieldName;
    if (fieldName === null || fieldName === undefined) {
      throw new Error('Required parameter fieldName was null or undefined when calling queryFieldValuesAttributes.');
    }
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const dataSources = requestParameters?.dataSources;
    const name = requestParameters?.name;
    const isPlaceholder = requestParameters?.isPlaceholder;
    const isRuleRelevant = requestParameters?.isRuleRelevant;
    const isGlobal = requestParameters?.isGlobal;
    const hasPreviousValue = requestParameters?.hasPreviousValue;
    const isMultipleAssignmentAllowed = requestParameters?.isMultipleAssignmentAllowed;
    const effectiveTo = requestParameters?.effectiveTo;
    const targetProperty = requestParameters?.targetProperty;
    const discriminator = requestParameters?.discriminator;
    const type = requestParameters?.type;
    const interdependencyId = requestParameters?.interdependencyId;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (legalEntity) {
      legalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntity');
      });
    }
    if (dataSources) {
      dataSources.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DataSources');
      });
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (isPlaceholder !== undefined && isPlaceholder !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isPlaceholder, 'IsPlaceholder');
    }
    if (isRuleRelevant !== undefined && isRuleRelevant !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isRuleRelevant, 'IsRuleRelevant');
    }
    if (isGlobal !== undefined && isGlobal !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isGlobal, 'IsGlobal');
    }
    if (hasPreviousValue !== undefined && hasPreviousValue !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hasPreviousValue,
        'HasPreviousValue'
      );
    }
    if (isMultipleAssignmentAllowed !== undefined && isMultipleAssignmentAllowed !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isMultipleAssignmentAllowed,
        'IsMultipleAssignmentAllowed'
      );
    }
    if (effectiveTo !== undefined && effectiveTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveTo, 'EffectiveTo');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (discriminator !== undefined && discriminator !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>discriminator, 'Discriminator');
    }
    if (type) {
      type.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Type');
      });
    }
    if (interdependencyId !== undefined && interdependencyId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>interdependencyId,
        'InterdependencyId'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<Array<string>>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesEmployeeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<string>>;
  public queryFieldValuesEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesEmployeeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<string>>>;
  public queryFieldValuesEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesEmployeeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<string>>>;
  public queryFieldValuesEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesEmployeeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling queryFieldValuesEmployeeAttributes.'
      );
    }
    const fieldName = requestParameters?.fieldName;
    if (fieldName === null || fieldName === undefined) {
      throw new Error(
        'Required parameter fieldName was null or undefined when calling queryFieldValuesEmployeeAttributes.'
      );
    }
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const targetProperty = requestParameters?.targetProperty;
    const employeeId2 = requestParameters?.employeeId2;
    const attributeName = requestParameters?.attributeName;
    const dataSource = requestParameters?.dataSource;
    const effectiveFrom = requestParameters?.effectiveFrom;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (employeeId2 !== undefined && employeeId2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>employeeId2, 'EmployeeId');
    }
    if (attributeName) {
      attributeName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AttributeName');
      });
    }
    if (dataSource) {
      dataSource.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DataSource');
      });
    }
    if (effectiveFrom !== undefined && effectiveFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveFrom, 'EffectiveFrom');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attributes/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<Array<string>>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesSignatureAuthorizationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesSignatureAuthorizationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesSignatureAuthorizationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryFieldValuesSignatureAuthorizationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryTargetProperty = requestParameters?.queryTargetProperty;
    const queryLegalEntity = requestParameters?.queryLegalEntity;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryTargetProperty !== undefined && queryTargetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTargetProperty,
        'Query.TargetProperty'
      );
    }
    if (queryLegalEntity) {
      queryLegalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LegalEntity');
      });
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/signature-authorizations/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryLegalEntityAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryLegalEntityAttributesAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryAttributesStandardAttributeModel>;
  public queryLegalEntityAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryLegalEntityAttributesAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryAttributesStandardAttributeModel>>;
  public queryLegalEntityAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryLegalEntityAttributesAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryAttributesStandardAttributeModel>>;
  public queryLegalEntityAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryLegalEntityAttributesAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const dataSources = requestParameters?.dataSources;
    const name = requestParameters?.name;
    const isPlaceholder = requestParameters?.isPlaceholder;
    const isRuleRelevant = requestParameters?.isRuleRelevant;
    const isGlobal = requestParameters?.isGlobal;
    const hasPreviousValue = requestParameters?.hasPreviousValue;
    const isMultipleAssignmentAllowed = requestParameters?.isMultipleAssignmentAllowed;
    const effectiveTo = requestParameters?.effectiveTo;
    const targetProperty = requestParameters?.targetProperty;
    const discriminator = requestParameters?.discriminator;
    const type = requestParameters?.type;
    const interdependencyId = requestParameters?.interdependencyId;
    const module = requestParameters?.module;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const module2 = requestParameters?.module2;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (legalEntity) {
      legalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntity');
      });
    }
    if (dataSources) {
      dataSources.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DataSources');
      });
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (isPlaceholder !== undefined && isPlaceholder !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isPlaceholder, 'IsPlaceholder');
    }
    if (isRuleRelevant !== undefined && isRuleRelevant !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isRuleRelevant, 'IsRuleRelevant');
    }
    if (isGlobal !== undefined && isGlobal !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isGlobal, 'IsGlobal');
    }
    if (hasPreviousValue !== undefined && hasPreviousValue !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hasPreviousValue,
        'HasPreviousValue'
      );
    }
    if (isMultipleAssignmentAllowed !== undefined && isMultipleAssignmentAllowed !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isMultipleAssignmentAllowed,
        'IsMultipleAssignmentAllowed'
      );
    }
    if (effectiveTo !== undefined && effectiveTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveTo, 'EffectiveTo');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (discriminator !== undefined && discriminator !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>discriminator, 'Discriminator');
    }
    if (type) {
      type.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Type');
      });
    }
    if (interdependencyId !== undefined && interdependencyId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>interdependencyId,
        'InterdependencyId'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (module2 !== undefined && module2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module2, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/legal-entity`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryAttributesStandardAttributeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQuerySignatureAuthorizationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>;
  public querySignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQuerySignatureAuthorizationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>
  >;
  public querySignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQuerySignatureAuthorizationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpEvent<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>
  >;
  public querySignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceQuerySignatureAuthorizationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryTargetProperty = requestParameters?.queryTargetProperty;
    const queryLegalEntity = requestParameters?.queryLegalEntity;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryTargetProperty !== undefined && queryTargetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTargetProperty,
        'Query.TargetProperty'
      );
    }
    if (queryLegalEntity) {
      queryLegalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LegalEntity');
      });
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/signature-authorizations`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryStandardAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryStandardAttributesAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryAttributesStandardAttributeModel>;
  public queryStandardAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryStandardAttributesAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryAttributesStandardAttributeModel>>;
  public queryStandardAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryStandardAttributesAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryAttributesStandardAttributeModel>>;
  public queryStandardAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryStandardAttributesAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const dataSources = requestParameters?.dataSources;
    const name = requestParameters?.name;
    const isPlaceholder = requestParameters?.isPlaceholder;
    const isRuleRelevant = requestParameters?.isRuleRelevant;
    const isGlobal = requestParameters?.isGlobal;
    const hasPreviousValue = requestParameters?.hasPreviousValue;
    const isMultipleAssignmentAllowed = requestParameters?.isMultipleAssignmentAllowed;
    const effectiveTo = requestParameters?.effectiveTo;
    const targetProperty = requestParameters?.targetProperty;
    const discriminator = requestParameters?.discriminator;
    const type = requestParameters?.type;
    const interdependencyId = requestParameters?.interdependencyId;
    const module = requestParameters?.module;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const module2 = requestParameters?.module2;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (legalEntity) {
      legalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntity');
      });
    }
    if (dataSources) {
      dataSources.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DataSources');
      });
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (isPlaceholder !== undefined && isPlaceholder !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isPlaceholder, 'IsPlaceholder');
    }
    if (isRuleRelevant !== undefined && isRuleRelevant !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isRuleRelevant, 'IsRuleRelevant');
    }
    if (isGlobal !== undefined && isGlobal !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isGlobal, 'IsGlobal');
    }
    if (hasPreviousValue !== undefined && hasPreviousValue !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hasPreviousValue,
        'HasPreviousValue'
      );
    }
    if (isMultipleAssignmentAllowed !== undefined && isMultipleAssignmentAllowed !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isMultipleAssignmentAllowed,
        'IsMultipleAssignmentAllowed'
      );
    }
    if (effectiveTo !== undefined && effectiveTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveTo, 'EffectiveTo');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (discriminator !== undefined && discriminator !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>discriminator, 'Discriminator');
    }
    if (type) {
      type.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Type');
      });
    }
    if (interdependencyId !== undefined && interdependencyId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>interdependencyId,
        'InterdependencyId'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (module2 !== undefined && module2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module2, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/standard`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryAttributesStandardAttributeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryUsers(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryUsersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryUsersUserModel>;
  public queryUsers(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryUsersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryUsersUserModel>>;
  public queryUsers(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryUsersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryUsersUserModel>>;
  public queryUsers(
    requestParameters?: EmploymentConditionLibraryAdminServiceQueryUsersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const searchString = requestParameters?.searchString;
    const firstname = requestParameters?.firstname;
    const lastname = requestParameters?.lastname;
    const middlename = requestParameters?.middlename;
    const gid = requestParameters?.gid;
    const isApproverAuthorized = requestParameters?.isApproverAuthorized;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (searchString !== undefined && searchString !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchString, 'SearchString');
    }
    if (firstname) {
      firstname.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Firstname');
      });
    }
    if (lastname) {
      lastname.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Lastname');
      });
    }
    if (middlename) {
      middlename.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Middlename');
      });
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (isApproverAuthorized !== undefined && isApproverAuthorized !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isApproverAuthorized,
        'IsApproverAuthorized'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/users`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryUsersUserModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceRecalculateSettingsSignatureAuthorizationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public recalculateSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceRecalculateSettingsSignatureAuthorizationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public recalculateSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceRecalculateSettingsSignatureAuthorizationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public recalculateSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceRecalculateSettingsSignatureAuthorizationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/signature-authorizations/recalculate`;
    return this.httpClient.request<TransactionStatusOfSimpleStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public replaceEmployeeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceReplaceEmployeeEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public replaceEmployeeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceReplaceEmployeeEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public replaceEmployeeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceReplaceEmployeeEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public replaceEmployeeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceReplaceEmployeeEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling replaceEmployeeEmployees.');
    }
    const employmentConditionLibraryEmployeesReplaceEmployeeModel =
      requestParameters?.employmentConditionLibraryEmployeesReplaceEmployeeModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/replace`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryEmployeesReplaceEmployeeModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendPendingClauseApprovalReminderControllerPendingClauseApprovalReminder(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public sendPendingClauseApprovalReminderControllerPendingClauseApprovalReminder(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public sendPendingClauseApprovalReminderControllerPendingClauseApprovalReminder(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public sendPendingClauseApprovalReminderControllerPendingClauseApprovalReminder(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/pending-clause-approval-reminder`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendPendingTemplateApprovalReminderControllerPendingTemplateApprovalReminder(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public sendPendingTemplateApprovalReminderControllerPendingTemplateApprovalReminder(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public sendPendingTemplateApprovalReminderControllerPendingTemplateApprovalReminder(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public sendPendingTemplateApprovalReminderControllerPendingTemplateApprovalReminder(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/pending-template-approval-reminder`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setUserAsApproverUsers(
    requestParameters?: EmploymentConditionLibraryAdminServiceSetUserAsApproverUsersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public setUserAsApproverUsers(
    requestParameters?: EmploymentConditionLibraryAdminServiceSetUserAsApproverUsersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public setUserAsApproverUsers(
    requestParameters?: EmploymentConditionLibraryAdminServiceSetUserAsApproverUsersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public setUserAsApproverUsers(
    requestParameters?: EmploymentConditionLibraryAdminServiceSetUserAsApproverUsersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryUsersSetUsersAsApproverModel =
      requestParameters?.employmentConditionLibraryUsersSetUsersAsApproverModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/users`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryUsersSetUsersAsApproverModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public translateEmployeeAttributeEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceTranslateEmployeeAttributeEmployeeAttributeTranslationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeValueTranslationModel>>;
  public translateEmployeeAttributeEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceTranslateEmployeeAttributeEmployeeAttributeTranslationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<Array<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeValueTranslationModel>>
  >;
  public translateEmployeeAttributeEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceTranslateEmployeeAttributeEmployeeAttributeTranslationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeValueTranslationModel>>>;
  public translateEmployeeAttributeEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceTranslateEmployeeAttributeEmployeeAttributeTranslationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employmentConditionLibraryEmployeeAttributesTranslateEmployeeAttributeValueModel =
      requestParameters?.employmentConditionLibraryEmployeeAttributesTranslateEmployeeAttributeValueModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/attributes/translate`;
    return this.httpClient.request<
      Array<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeValueTranslationModel>
    >('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: employmentConditionLibraryEmployeeAttributesTranslateEmployeeAttributeValueModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public translateEmployeeAttributesEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceTranslateEmployeeAttributesEmployeeAttributeTranslationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributesTranslationModel>;
  public translateEmployeeAttributesEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceTranslateEmployeeAttributesEmployeeAttributeTranslationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributesTranslationModel>>;
  public translateEmployeeAttributesEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceTranslateEmployeeAttributesEmployeeAttributeTranslationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributesTranslationModel>>;
  public translateEmployeeAttributesEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceTranslateEmployeeAttributesEmployeeAttributeTranslationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employmentConditionLibraryEmployeeAttributesMassTranslateEmployeeAttributesModel =
      requestParameters?.employmentConditionLibraryEmployeeAttributesMassTranslateEmployeeAttributesModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/attributes/mass-translate`;
    return this.httpClient.request<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributesTranslationModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryEmployeeAttributesMassTranslateEmployeeAttributesModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateCalculatedAttributeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryAttributesCalculatedAttributeModel>;
  public updateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateCalculatedAttributeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryAttributesCalculatedAttributeModel>>;
  public updateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateCalculatedAttributeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryAttributesCalculatedAttributeModel>>;
  public updateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateCalculatedAttributeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryAttributesUpdateCalculatedAttributeModel =
      requestParameters?.employmentConditionLibraryAttributesUpdateCalculatedAttributeModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/calculated`;
    return this.httpClient.request<EmploymentConditionLibraryAttributesCalculatedAttributeModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryAttributesUpdateCalculatedAttributeModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateClauseCategoriesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClauseCategoriesClauseCategoryModel>;
  public updateClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateClauseCategoriesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClauseCategoriesClauseCategoryModel>>;
  public updateClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateClauseCategoriesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClauseCategoriesClauseCategoryModel>>;
  public updateClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateClauseCategoriesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryClauseCategoriesUpdateClauseCategoryModel =
      requestParameters?.employmentConditionLibraryClauseCategoriesUpdateClauseCategoryModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/clause-categories`;
    return this.httpClient.request<EmploymentConditionLibraryClauseCategoriesClauseCategoryModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClauseCategoriesUpdateClauseCategoryModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateCountryNumberSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>;
  public updateCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateCountryNumberSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>>;
  public updateCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateCountryNumberSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>>;
  public updateCountryNumberSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateCountryNumberSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateCountryNumberSettings.');
    }
    const employmentConditionLibraryCountryNumberSettingsUpdateCountryNumberSettingModel =
      requestParameters?.employmentConditionLibraryCountryNumberSettingsUpdateCountryNumberSettingModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/country-number-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryCountryNumberSettingsCountryNumberSettingModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryCountryNumberSettingsUpdateCountryNumberSettingModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateDependentAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateDependentAttributeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryAttributesDependentAttributeModel>;
  public updateDependentAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateDependentAttributeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryAttributesDependentAttributeModel>>;
  public updateDependentAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateDependentAttributeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryAttributesDependentAttributeModel>>;
  public updateDependentAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateDependentAttributeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryAttributesUpdateDependentAttributeModel =
      requestParameters?.employmentConditionLibraryAttributesUpdateDependentAttributeModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/dependent`;
    return this.httpClient.request<EmploymentConditionLibraryAttributesDependentAttributeModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryAttributesUpdateDependentAttributeModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEclSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEclSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryEclSettingsEclSettingsModel>;
  public updateEclSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEclSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryEclSettingsEclSettingsModel>>;
  public updateEclSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEclSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryEclSettingsEclSettingsModel>>;
  public updateEclSettings(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEclSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateEclSettings.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryEclSettingsUpdateEclSettingsModel =
      requestParameters?.employmentConditionLibraryEclSettingsUpdateEclSettingsModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryEclSettingsEclSettingsModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryEclSettingsUpdateEclSettingsModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeAresEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAresEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<EmploymentConditionLibraryEmployeesEmployeeAreModel>>;
  public updateEmployeeAresEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAresEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<EmploymentConditionLibraryEmployeesEmployeeAreModel>>>;
  public updateEmployeeAresEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAresEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<EmploymentConditionLibraryEmployeesEmployeeAreModel>>>;
  public updateEmployeeAresEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAresEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling updateEmployeeAresEmployees.');
    }
    const employmentConditionLibraryEmployeesUpdateEmployeeAreModel =
      requestParameters?.employmentConditionLibraryEmployeesUpdateEmployeeAreModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/update-ares`;
    return this.httpClient.request<Array<EmploymentConditionLibraryEmployeesEmployeeAreModel>>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryEmployeesUpdateEmployeeAreModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeAttributeValuesEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAttributeValuesEmployeeAttributeTranslationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public updateEmployeeAttributeValuesEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAttributeValuesEmployeeAttributeTranslationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public updateEmployeeAttributeValuesEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAttributeValuesEmployeeAttributeTranslationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public updateEmployeeAttributeValuesEmployeeAttributeTranslation(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAttributeValuesEmployeeAttributeTranslationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employmentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeTranslationModel =
      requestParameters?.employmentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeTranslationModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/attributes`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeTranslationModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>;
  public updateEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>>;
  public updateEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>>;
  public updateEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateEmployeeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling updateEmployeeAttributes.');
    }
    const employmentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeModel =
      requestParameters?.employmentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attributes`;
    return this.httpClient.request<EmploymentConditionLibraryEmployeeAttributesEmployeeAttributeDetailsModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryEmployeeAttributesUpdateEmployeeAttributeModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateLegalEntityAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateLegalEntityAttributeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryAttributesStandardAttributeModel>;
  public updateLegalEntityAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateLegalEntityAttributeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryAttributesStandardAttributeModel>>;
  public updateLegalEntityAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateLegalEntityAttributeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryAttributesStandardAttributeModel>>;
  public updateLegalEntityAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateLegalEntityAttributeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryAttributesUpdateStandardAttributeModel =
      requestParameters?.employmentConditionLibraryAttributesUpdateStandardAttributeModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/legal-entity`;
    return this.httpClient.request<EmploymentConditionLibraryAttributesStandardAttributeModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryAttributesUpdateStandardAttributeModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateSettingsSignatureAuthorizationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>;
  public updateSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateSettingsSignatureAuthorizationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>>;
  public updateSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateSettingsSignatureAuthorizationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>>;
  public updateSettingsSignatureAuthorizations(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateSettingsSignatureAuthorizationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibrarySignatureAuthorizationsUpdateSignatureAuthorizationSettingsModel =
      requestParameters?.employmentConditionLibrarySignatureAuthorizationsUpdateSignatureAuthorizationSettingsModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/signature-authorizations`;
    return this.httpClient.request<EmploymentConditionLibrarySignatureAuthorizationsSignatureAuthorizationItemModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibrarySignatureAuthorizationsUpdateSignatureAuthorizationSettingsModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateStandardAttributeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryAttributesStandardAttributeModel>;
  public updateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateStandardAttributeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryAttributesStandardAttributeModel>>;
  public updateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateStandardAttributeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryAttributesStandardAttributeModel>>;
  public updateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminServiceUpdateStandardAttributeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryAttributesUpdateStandardAttributeModel =
      requestParameters?.employmentConditionLibraryAttributesUpdateStandardAttributeModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/attributes/standard`;
    return this.httpClient.request<EmploymentConditionLibraryAttributesStandardAttributeModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryAttributesUpdateStandardAttributeModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceValidateEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<SharedUploadedGidsValidationResultModel>>;
  public validateEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceValidateEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<SharedUploadedGidsValidationResultModel>>>;
  public validateEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceValidateEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<SharedUploadedGidsValidationResultModel>>>;
  public validateEmployees(
    requestParameters?: EmploymentConditionLibraryAdminServiceValidateEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employmentConditionLibraryEmployeesUploadedGidsValidationRequestModel =
      requestParameters?.employmentConditionLibraryEmployeesUploadedGidsValidationRequestModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/admin/v1/employees/validate-gid-uploads`;
    return this.httpClient.request<Array<SharedUploadedGidsValidationResultModel>>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryEmployeesUploadedGidsValidationRequestModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }
}
